import React, { useState } from 'react';
import { openHorseCogginsDocument } from '../../utils/horseCareApi.ts';

interface CogginsViewLinkProps {
  horseId: string;
  children: React.ReactNode;
  className?: string;
}

export default function CogginsViewLink({ horseId, children, className = '' }: CogginsViewLinkProps) {
  const [opening, setOpening] = useState(false);

  return (
    <button
      type="button"
      disabled={opening}
      onClick={async () => {
        setOpening(true);
        try {
          await openHorseCogginsDocument(horseId);
        } finally {
          setOpening(false);
        }
      }}
      className={`text-left bg-transparent border-0 p-0 cursor-pointer disabled:opacity-60 ${className}`}
    >
      {opening ? 'Opening…' : children}
    </button>
  );
}
